import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ContactDetails from "./sections/ContactDetails";
import MessageForm from "./sections/MessageForm";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <ContactDetails />
      <MessageForm />
      <Footer />
    </div>;
}